import { useEffect, useState } from 'react'

export default function useCaptcha() {
  const [recaptchaLoaded, setRecaptchaLoaded] = useState(false)
  const [captchaValue, setCaptchaValue] = useState(false)

  function isValidEmail(email) {
    const invalidEmailRegex =
      /armyspy|cuvox|dayrep|einrot|fleckens|gustr|jourrapide|rhyta|superrito|teleworm/i
    const test = invalidEmailRegex.test(email)
    return !test
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const form = e.target
    const _form = new FormData(form)
    const hasPosition = _form.get('position')
    const email = _form.get('email')

    if (!hasPosition && captchaValue && isValidEmail(email)) {
      form.submit()
    }
  }

  useEffect(() => {
    if (!recaptchaLoaded) return

    function timestamp() {
      var elems = JSON.parse(
        document.getElementsByName('captcha_settings')[0].value
      )
      elems['ts'] = JSON.stringify(new Date().getTime())
      document.getElementsByName('captcha_settings')[0].value =
        JSON.stringify(elems)
    }

    const interval = setInterval(timestamp, 500)

    return () => clearInterval(interval)
  }, [recaptchaLoaded])

  return {
    captchaValue,
    setRecaptchaLoaded,
    setCaptchaValue,
    handleSubmit,
  }
}
